import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileViewProgress } from './MobileViewProgress';

interface LayoutProps {
  children: ReactNode;
  className?: string;
}

export function Layout({ children, className = '' }: LayoutProps) {
  return (
    <div className={`flex min-h-screen flex-col bg-canvas text-fg ${className}`}>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileViewProgress />
    </div>
  );
}
